export const resourceType = {
    'Show Room' : 'res:preselect',
    'Trimmed':'res:trimmed',
    'Self Gen':'res:self-gen',
    'Renewal' : 'res:3g-upgrade',
    'Onit Home' : 'res:onit',
    'Authorized Partner Security' : 'res:dealer-program'
}
